<template>
  <div>
    <Navbar></Navbar>
    <div v-if="cartNotEmpty">
      <div style="margin-top: 40px;" class="container border shadow">
        <div style="display:flex; justify-content: space-between;">
          <h5>Product</h5>
          <h5 style="margin-left: 350px;">Total Harga</h5>
          <h5>Jumlah Produk</h5>
          <h5>Action</h5>
        </div>
      </div>
      <div
        class="container border shadow"
        style="margin-top: 20px;"
        v-for="item in this.$store.state.listCart"
        :key="item.id"
      >
        <div style="display:flex; justify-content: space-around;">
          <img
            style="width: 200px; height: 200px; margin-right: 50px;"
            :src="item.Products.image_url"
          />
          <p style="margin-top:80px; margin-right:100px; text-align: left; ">
            {{ item.Products.name }}
          </p>
          <p style="margin-top:80px; margin-right:100px; text-align: left;">
            {{ price(Number(item.Products.price) * Number(item.quantity)) }}
          </p>
          <p style="text-align: left; margin-top:80px; margin-right:100px;">{{ item.quantity }}</p>
          <button
            type="button"
            @click="deleteItem(item.id)"
            class="btn border-danger btn-danger"
            style="width: 100px; height: 50px; margin-top:80px;"
          >
            Hapus
          </button>
        </div>
      </div>
      <div
        class="container border shadow bg-light"
        style="position: fixed; bottom: 0;  margin-left:70px;"
      >
        <div style="display:flex; justify-content: space-around; margin: 15px; 0px;">
          <h5>Total Belanjaan:</h5>
          <h3>{{ price(totalPrice) }}</h3>
          <button
            @click="buyAll"
            style="width: 100px; height: 50px;"
            class="btn border-light btn-success"
          >
            Beli
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <h3 style="margin-top:100px; font-weight: bold;">Wah, keranjang belanjamu kosong</h3>
      <p>Daripada dianggurin, mending isi dengan barang-barang impianmu.</p>
      <p>Yuk, cek sekarang!</p>
      <button
        @click="goToHome"
        type="button"
        style="background-color:#039A0C; color:white; width: 200px;"
        class="btn"
      >
        Mulai Belanja
      </button>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import Navbar from "../components/Navbar.vue";
export default {
  data() {
    return {};
  },
  methods: {
    deleteItem(id) {
      swal({
        title: "Apakah anda yakin ingin menghapus item ini?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          swal("Barang yang dipilih sudah berhasil dihapus!", {
            icon: "success"
          });
          this.$store.dispatch("deleteCart", id);
        } else {
        }
      });
    },
    buyAll() {
      swal({
        title: "Apakah barang yang anda pilih sudah benar?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          swal("Berhasil membeli barang!", {
            icon: "success"
          });
          this.$store.dispatch("buyAllItem");
        } else {
        }
      });
    },
    price(angka) {
      var rupiah = "";
      var angkarev = angka
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return (
        "Rp. " +
        rupiah
          .split("", rupiah.length - 1)
          .reverse()
          .join("")
      );
    },
    goToHome() {
      this.$router.push({ name: "Home" });
    }
  },
  computed: {
    totalPrice: function() {
      let price = 0;
      const data = this.$store.state.listCart;
      for (let i = 0; i < data.length; i++) {
        price += Number(data[i].Products.price) * Number(data[i].quantity);
      }
      console.log(price, "Ini harga");
      return price;
    },
    cartNotEmpty: function() {
      let data = this.$store.state.listCart.length;
      if (data === 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    this.$store.dispatch("readCart");
  },
  components: {
    Navbar
  }
};
</script>

<style></style>
